module.exports = __webpack_public_path__ + "img/firebase.5b979dad.svg";